import { render, staticRenderFns } from "./gxzy_detail.vue?vue&type=template&id=e68b440e&"
import script from "./gxzy_detail.vue?vue&type=script&lang=js&"
export * from "./gxzy_detail.vue?vue&type=script&lang=js&"
import style0 from "./gxzy_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports